<div class="order-status-box">
  <div class="order-status-content">
    @if (isLoading()) {
      <div class="order-status-state">
        <ion-spinner name="crescent" class="order-status-spinner"></ion-spinner>
        <div class="order-status-text">
          <div class="order-status-title">
            {{ 'order_statusPending' | translate }}
          </div>
          <div class="order-status-sub">
            {{ 'order_statusPendingIntro' | translate }}
          </div>
        </div>
      </div>
    } @else {
      @switch (orderState()) {
        @case (OrderState.succeeded) {
          <div class="order-status-state">
            <ion-icon
              name="checkmark-circle-outline"
              class="order-status-icon order-status-icon--success"
            ></ion-icon>
            <div class="order-status-text">
              <div class="order-status-title">
                {{ 'order_statusSucceeded' | translate }}
              </div>
              <div class="order-status-sub">
                {{ 'order_statusSucceededIntro' | translate }}
              </div>
            </div>
          </div>
        }
        @case (OrderState.pending) {
          <div class="order-status-state">
            <ion-icon
              name="time-outline"
              class="order-status-icon order-status-icon--pending"
            ></ion-icon>
            <div class="order-status-text">
              <div class="order-status-title">
                {{ 'order_statusPending' | translate }}
              </div>
              <div class="order-status-sub">
                {{ 'order_statusPendingIntro' | translate }}
              </div>
            </div>
          </div>
        }
        @case (OrderState.failed) {
          <div class="order-status-state">
            <ion-icon
              name="close-circle-outline"
              class="order-status-icon order-status-icon--failed"
            ></ion-icon>
            <div class="order-status-text">
              <div class="order-status-title">
                {{ 'order_statusFailed' | translate }}
              </div>
              <div class="order-status-sub">
                {{ 'order_statusFailedIntro' | translate }}
              </div>
            </div>
          </div>
        }
        @case (OrderState.error) {
          <div class="order-status-state">
            <ion-icon
              name="warning-outline"
              class="order-status-icon order-status-icon--error"
            ></ion-icon>
            <div class="order-status-text">
              <div class="order-status-title">
                {{ 'order_statusError' | translate }}
              </div>
              <div class="order-status-sub">
                {{ 'order_statusErrorIntro' | translate }}
              </div>
            </div>
          </div>
          <button class="order-status-reload" (click)="onReload()">
            <ion-icon name="refresh-outline"></ion-icon>
            <span>{{ 'order_statusReload' | translate }}</span>
          </button>
        }
      }
    }
  </div>
</div>
